import React from 'react';
import SecondNav from "../Navbar/SecondNav";
import TopNavbar from "../Navbar/TopNavbar";
import ChatPopup from "./ChatPopup";
import { Box, Typography, TextField, Button, Container, useTheme, useMediaQuery } from '@mui/material';
import Footer from './Footer';

function Contact() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div
      className="home-page"
      style={{
        width: "100%",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        position: "relative",
      }}
    >
      <TopNavbar />
      <SecondNav />

      {/* Contact Section */}
      <Box
        sx={{
          py: 8,
          backgroundImage: 'url(https://media.istockphoto.com/id/879766344/photo/car-driving-on-a-road-by-sea.jpg?s=612x612&w=0&k=20&c=GqWcx8xj-na9tWWErQ2jFf3c5kO8W7VYGw2GrOv4zfo=)', // Car-themed background image
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          position: 'relative',
          zIndex: 1,
          '&::before': {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            // background: "rgba(0, 0, 0, 0.7)", // Dark overlay for readability
            zIndex: -1,
          },
          mt: 4,
        }}
      >
        <Container maxWidth="md">
          <Typography
            variant="h3"
            sx={{
              fontWeight: 'bold',
              color: '#1E88E5',
              textAlign: 'center',
              mb: 5,
              fontFamily: 'Arial, sans-serif',
            }}
          >
            Contact Us
          </Typography>

          <Typography
            variant="h6"
            sx={{
              textAlign: 'center',
              maxWidth: '800px',
              mx: 'auto',
              mb: 4,
              color: 'black', // Changed to white for better contrast on dark overlay
              fontSize: { xs: '1.2rem', md: '1.5rem' },
              fontWeight: 600,
            }}
          >
            We'd love to hear from you! Fill out the form below to get in touch.
          </Typography>

          {/* Contact Form */}
          <Box
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.95)', // Slightly transparent white for better contrast
              borderRadius: 4,
              boxShadow: '0 6px 20px rgba(0,0,0,0.1)',
              p: { xs: 3, sm: 5 },
              border: '1px solid #1E88E5',
            }}
          >
            <Box
              component="form"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
              }}
            >
              <TextField
                label="Name"
                variant="outlined"
                fullWidth
                required
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': { borderColor: '#1E88E5' },
                    '&:hover fieldset': { borderColor: '#1565C0' },
                    '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
                  },
                  '& .MuiInputLabel-root': { color: '#666' },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
                }}
              />
              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                required
                type="email"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': { borderColor: '#1E88E5' },
                    '&:hover fieldset': { borderColor: '#1565C0' },
                    '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
                  },
                  '& .MuiInputLabel-root': { color: '#666' },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
                }}
              />
              <TextField
                label="Phone"
                variant="outlined"
                fullWidth
                type="tel"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': { borderColor: '#1E88E5' },
                    '&:hover fieldset': { borderColor: '#1565C0' },
                    '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
                  },
                  '& .MuiInputLabel-root': { color: '#666' },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
                }}
              />
              <TextField
                label="Message"
                variant="outlined"
                fullWidth
                required
                multiline
                rows={4}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '& fieldset': { borderColor: '#1E88E5' },
                    '&:hover fieldset': { borderColor: '#1565C0' },
                    '&.Mui-focused fieldset': { borderColor: '#1E88E5' },
                  },
                  '& .MuiInputLabel-root': { color: '#666' },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#1E88E5' },
                }}
              />
              <Button
                variant="contained"
                sx={{
                  backgroundColor: '#1E88E5',
                  color: '#fff',
                  fontWeight: '600',
                  borderRadius: 2,
                  padding: '12px 0',
                  mt: 2,
                  '&:hover': { backgroundColor: '#1565C0' },
                }}
                type="submit"
              >
                Send Message
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>

      <ChatPopup />
      <Footer />
    </div>
  );
}

export default Contact;